import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'promise-polyfill';
import 'whatwg-fetch';
import 'intl';

if (!('ontouchstart' in document.documentElement)) {
  document.documentElement.className += ' no-touch';
}
